import React, { useState, useEffect } from 'react'
import { Switch, Tree, Input, Message } from '@arco-design/web-react'
import { IconFile, IconFolder, IconLoading } from '@arco-design/web-react/icon'
import {
  IconDownload,
  IconUse,
  IconSuccessTip,
  IconWarnTip,
  IconErrorTip,
} from '@arco-iconbox/react-aidb-v2'
import { getNewsLibraryExport, getNewsLibraryExportDownload } from './utils/api'
import Empty from './Empty'
import styles from './style/search-export-mod.module.less'

const TreeNode = Tree.Node

function SearchExportMod(props) {
  const {
    visible,
    setVisible,
    contentStationIdValue,
    newsKeywordsValue,
    subtitleKeywordsValue,
    timeSlot,
  } = props
  // 树原始数据
  const [treeDataOriginal, setTreeDataOriginal] = useState<Array<any>>([])
  // 树数据
  const [treeData, setTreeData] = useState<Array<any>>(treeDataOriginal)
  // 搜索上下文loading
  const [searchContentDataLoading, setSearchContentDataLoading] =
    useState<boolean>(false)
  // 导出下载loading
  const [exportDownloadLoading, setExportDownloadLoading] =
    useState<boolean>(false)
  // 树搜索
  const [inputValue, setInputValue] = useState<string>('')
  // 需要导出的id
  const [id, setId] = useState<Array<string>>([])
  // 点击详情值
  const [isExportNeedImg, setIsExportNeedImg] = useState<boolean>(false)

  useEffect(() => {
    if (!visible) return
    setSearchContentDataLoading(true)
    // 书籍库上下文
    getNewsLibraryExport({
      stationId: contentStationIdValue,
      newsKeywords: newsKeywordsValue,
      subtitleKeywords: subtitleKeywordsValue,
      timeSlot: timeSlot,
    })
      .then((res) => {
        if (res.status === 200) {
          setTreeDataOriginal(res.data)
          setTreeData(res.data)
        } else {
          Message.error({
            icon: <IconErrorTip useCurrentColor={false} />,
            content: '搜索失败，请重试！',
          })
        }
        setSearchContentDataLoading(false)
      })
      .catch((err) => {
        Message.error({
          icon: <IconErrorTip useCurrentColor={false} />,
          content: '搜索失败，请重试！',
        })
        setSearchContentDataLoading(false)
      })
  }, [visible])

  useEffect(() => {
    if (!inputValue) {
      setTreeData(JSON.parse(JSON.stringify(treeDataOriginal)))
    } else {
      const { result, keys } = searchData(
        inputValue,
        JSON.parse(JSON.stringify(treeData)),
      )
      setTreeData(result)
    }
  }, [inputValue])

  // 搜索树
  function searchData(inputValue, data) {
    const loop = (data, parentKey = []) => {
      let result = []
      let keys = []

      data.forEach((item) => {
        let currentKey = [...parentKey, item.key]
        if (item.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1) {
          keys.push(...currentKey)
          result.push({ ...item })
        }
        if (item.children) {
          const childrenResult = loop(item.children, currentKey)
          keys = [...keys, ...childrenResult.keys]

          if (childrenResult.result.length) {
            result.push({ ...item, children: childrenResult.result })
          }
        }
      })

      return { result, keys }
    }

    return loop(data)
  }

  // 树节点
  function renderTreeNodes(data) {
    return data.map((item, index) => (
      <TreeNode
        // icon={item.children ? <IconFolder /> : <IconFile />}
        icons={{
          switcherIcon:
            item.children && item.children.length ? (
              <IconFolder />
            ) : (
              <IconFile />
            ),
        }}
        key={item.url + '---' + item.key + '---' + index}
        title={item.title ? item.title : item.children.length}>
        {item.children ? renderTreeNodes(item.children) : null}
      </TreeNode>
    ))
  }

  // 导出下载
  const exportDownload = () => {
    if (!id.length) {
      Message.error({
        icon: <IconErrorTip useCurrentColor={false} />,
        content: '请选择需要导出的内容！',
      })
      return
    }
    let filename, filePath

    function getRandomNumber(digits) {
      let min = Math.pow(10, digits - 1) // 计算最小值
      let max = Math.pow(10, digits) - 1 // 计算最大值
      return Math.floor(Math.random() * (max - min + 1)) + min
    }

    setExportDownloadLoading(true)
    getNewsLibraryExportDownload({
      ids: id,
      isExportNeedImg,
      stationId: contentStationIdValue,
      timeSlot: timeSlot,
    })
      .then((response) => {
        const header = response.headers.get('Content-Disposition')
        filePath = response.headers.get('File-Path')
        const parts = header.split(';')
        filename = parts[1].split('=')[1].replaceAll('"', '')
        return response.blob()
      }) //定义返回的类型和数据格式
      .then((blob) => {
        // 返回的数据

        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)

        // Append to html link element page
        document.body.appendChild(link)

        // Start download
        link.click()

        // Clean up and remove the link
        link.parentNode.removeChild(link)
        window.URL.revokeObjectURL(url)

        // record download history
        fetch(
          'https://ias.zgbjds.com/?record_download_history_news=' +
            filename +
            '&url=' +
            filePath,
          {
            method: 'GET',
            // credentials: 'same-origin',
            // headers: new Headers({ 'Content-Type': 'application/json' }),
          },
        )
          .then(function (data) {
            // 返回的数据
            setExportDownloadLoading(false)
            setVisible(false)
          })
          .catch((error) => {
            setExportDownloadLoading(false)
            setVisible(false)
            console.error('Error:', error)
          })
      })
      .catch((error) => {
        setExportDownloadLoading(false)
        setVisible(false)
        console.error('Error:', error)
      })
  }

  // 整理需要下载的id值
  const mergeId = (checkedKeys) => {
    let arr = []
    checkedKeys.forEach((item) => {
      let ids = item.split('---')[1].split('_')[1]
      if (/^\d+$/.test(ids)) arr.push(ids)
    })

    return arr
  }

  return (
    <div className={styles['content']}>
      <div className={styles.title}>导出所选</div>
      <div className={styles.text}>
        {/* 搜索框 */}
        <Input.Search
          allowClear
          autoFocus
          value={inputValue}
          onChange={setInputValue}
          style={{
            width: '100%',
            marginBottom: 8,
          }}
        />
        {!searchContentDataLoading ? (
          <Tree
            blockNode
            checkable
            size={'large'}
            showLine={true}
            onSelect={(selectedKeys, extra) => {
              //   console.log(selectedKeys, extra)
              // console.log(selectedKeys[0].split('---')[0])
              if (selectedKeys[0].split('---')[0] === 'undefined') {
                Message.warning({
                  icon: <IconWarnTip useCurrentColor={true} />,
                  content: '无相关链接！',
                })
                return
              }
              window.open(selectedKeys[0].split('---')[0], '_blank')
              //   setSelectValue(extra.node.props.title.toString())
            }}
            onCheck={(checkedKeys, extra) => {
              //   console.log(checkedKeys, extra)
              setId(mergeId(checkedKeys))
            }}
            renderTitle={({ title }) => {
              if (typeof title === 'string' && inputValue) {
                const index = title
                  .toLowerCase()
                  .indexOf(inputValue.toLowerCase())
                if (index === -1) {
                  return title
                }
                const prefix = title.substr(0, index)
                const suffix = title.substr(index + inputValue.length)
                return (
                  <span>
                    {prefix}
                    <span style={{ color: '#AC1E1E' }}>
                      {title.substr(index, inputValue.length)}
                    </span>
                    {suffix}
                  </span>
                )
              }

              return title
            }}
            style={{
              maxHeight: 'calc(100% - 40px)',
              overflow: 'auto',
            }}>
            {renderTreeNodes(treeDataOriginal)}
          </Tree>
        ) : (
          <Empty state={searchContentDataLoading} />
        )}
      </div>
      <div className={styles.btn}>
        {exportDownloadLoading ? (
          <div
            className={styles.btnItem}
            onClick={() => {
              Message.warning({
                icon: <IconWarnTip useCurrentColor={true} />,
                content: '正在下载中...',
              })
            }}>
            <div className={styles.icon}>
              <IconLoading style={{ fill: 'none' }} />
            </div>
            <div className={styles.txt}>导出中...</div>
          </div>
        ) : (
          <div className={styles.btnItem} onClick={() => exportDownload()}>
            <div className={styles.icon}>
              <IconDownload useCurrentColor={true} />
            </div>
            <div className={styles.txt}>导出所选</div>
          </div>
        )}
        <div className={`${styles.switch} red-switch`}>
          <Switch
            size={'small'}
            checked={isExportNeedImg}
            onChange={setIsExportNeedImg}
          />
          <div className={styles.txt}>需要带图</div>
        </div>
      </div>
    </div>
  )
}

export default SearchExportMod
